module.exports = __webpack_public_path__ + "media/10.c9fcb76b.mp3";